module.exports = __webpack_public_path__ + "Server-Disabled.AzureWebApp.c41963d17825f1664cb97cecf552aea8.hashedasset.svg";